import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_fac_made_disabled_persons'

export const dataPointDefinition = {
  retracedId: 'has_fac_made_disabled_persons',
  name: 'Has the facility made accommodations/arrangements for physically disabled persons, although there are no applicable lega',
  description:
    'The intent of this question is to understand if the facility has made any types of special accommodations/ arrangements for physically disabled persons. ',
  meta: {
    slcpMeta: {
      key: 'disc-9',
      number: 'WT-DIS-16',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-9', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26910,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
